var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfinityQuickView = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.0077 27.8547C45.0077 22.951 42.5446 18.4408 38.4206 15.7897L36.3546 14.4613C37.1676 14.1455 37.7484 13.3593 37.7484 12.4352C37.7484 11.3274 36.9143 10.4207 35.8435 10.285L39.2002 6.92828V6.62774C39.2002 5.02126 37.9981 3.65941 36.4032 3.45978L35.0661 3.29282L35.763 1.02864L31.6491 0L29.7973 2.46816L28.6452 0.738997L23.7321 1.72191L24.2642 3.3175L23.1216 3.45978C21.5282 3.65941 20.326 5.02126 20.326 6.62774V6.92828L23.6827 10.285C22.612 10.4207 21.7779 11.3274 21.7779 12.4352C21.7779 13.3593 22.3587 14.1455 23.1724 14.4613L21.1064 15.7897C16.9817 18.4408 14.5186 22.951 14.5186 27.8547C14.5186 28.2815 14.544 28.7076 14.581 29.1316H7.5141L4.35558 36.237V36.3909H3.15852L0 43.4963V45.102H11.6149H13.0972H36.2965V43.4963L35.3644 41.3991C41.0797 39.4144 45.0077 33.9663 45.0077 27.8547ZM36.2232 4.90003C36.9985 4.9973 37.6039 5.5991 37.7251 6.34899L33.8182 10.2574H32.9238L34.6334 4.70112L36.2232 4.90003ZM27.9766 2.35347L29.7283 4.97988L32.232 1.6406L33.9256 2.06382L31.4045 10.2574H28.108L25.6304 2.82314L27.9766 2.35347ZM23.3031 4.90003L24.7332 4.72145L26.5785 10.2574H25.7081L21.8004 6.34899C21.9216 5.5991 22.5271 4.9973 23.3031 4.90003ZM23.9557 11.7093H35.5706C35.9713 11.7093 36.2965 12.0345 36.2965 12.4352C36.2965 12.8359 35.9713 13.1611 35.5706 13.1611H23.9557C23.555 13.1611 23.2298 12.8359 23.2298 12.4352C23.2298 12.0345 23.555 11.7093 23.9557 11.7093ZM30.4201 36.3909H17.4223V36.237L14.9099 30.5834H27.8402L30.4201 36.3909ZM8.45636 30.5834H13.3201L15.9015 36.3909H14.7727H5.87641L8.45636 30.5834ZM12.3408 41.8629L10.5543 37.8427H14.1281L12.3408 41.8629ZM4.10078 37.8427H4.35558H5.08151H8.96524L11.5466 43.6502H1.52082L4.10078 37.8427ZM15.7157 37.8427H20.5794L23.1608 43.6502H13.1357L15.7157 37.8427ZM24.6816 43.6502V43.4963L22.1692 37.8427H31.9409H32.1957L34.7764 43.6502H24.6816ZM34.7721 40.067L33.138 36.3909H31.9409V36.237L30.709 33.4647C32.6059 33.3485 34.1187 31.7834 34.1187 29.8575C34.1187 27.8561 32.4905 26.2279 30.4891 26.2279H29.0372C27.8365 26.2279 26.8594 25.2508 26.8594 24.0501C26.8594 22.8494 27.8365 21.8723 29.0372 21.8723H32.6669V24.0501H34.1187V20.4204H30.4891V18.9686H29.0372V20.4204C27.0358 20.4204 25.4076 22.0487 25.4076 24.0501C25.4076 26.0515 27.0358 27.6797 29.0372 27.6797H30.4891C31.6898 27.6797 32.6669 28.6568 32.6669 29.8575C32.6669 31.0582 31.6898 32.0353 30.4891 32.0353H30.0731L28.7824 29.1316H16.0409C15.9995 28.7084 15.9705 28.2822 15.9705 27.8547C15.9705 23.4475 18.1838 19.394 21.8912 17.0107L25.6203 14.613H33.9053L37.6344 17.0107C41.3425 19.394 43.5558 23.4475 43.5558 27.8547C43.5558 33.3892 39.9712 38.3175 34.7721 40.067Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4238 27.6681L18.8757 27.6906C18.9214 24.8145 20.2012 22.1017 22.3877 20.2477L21.4491 19.1406C18.9439 21.2647 17.4761 24.3731 17.4238 27.6681Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4727 18.3714L23.2835 19.575L24.3949 18.8577L23.6095 17.6367L22.4727 18.3714Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8867 31.6751L41.2268 32.234C41.425 31.7586 41.5927 31.2649 41.7248 30.7677L40.3208 30.3945C40.2061 30.8294 40.0602 31.2606 39.8867 31.6751Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.104 27.7109H40.6522L40.6529 27.8554C40.6529 28.2626 40.6282 28.6713 40.5781 29.0706L42.0184 29.2492C42.0757 28.7904 42.1048 28.3222 42.1048 27.8554L42.104 27.7109Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5215 34.009L39.6655 34.9019C39.9813 34.4983 40.2732 34.0685 40.5345 33.6228L39.2823 32.8867C39.0536 33.278 38.7973 33.6548 38.5215 34.009Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5879 35.8908L37.4525 37.0559C37.8641 36.7503 38.2612 36.412 38.6314 36.0513L37.618 35.0117C37.2949 35.3282 36.948 35.6237 36.5879 35.8908Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.4375 8.80859H10.8894V10.2605H9.4375V8.80859Z",
    fill: "#C59331"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.4375 11.7109H10.8894V13.1628H9.4375V11.7109Z",
    fill: "#C59331"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8887 10.2539H12.3405V11.7058H10.8887V10.2539Z",
    fill: "#C59331"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.98438 10.2539H9.43624V11.7058H7.98438V10.2539Z",
    fill: "#C59331"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1621 23.3242H11.614V24.7761H10.1621V23.3242Z",
    fill: "#C59331"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1621 26.2266H11.614V27.6784H10.1621V26.2266Z",
    fill: "#C59331"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6152 24.7773H13.0671V26.2292H11.6152V24.7773Z",
    fill: "#C59331"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.71094 24.7773H10.1628V26.2292H8.71094V24.7773Z",
    fill: "#C59331"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9707 1.54688H17.4226V2.99874H15.9707V1.54688Z",
    fill: "#C59331"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9707 4.45312H17.4226V5.90499H15.9707V4.45312Z",
    fill: "#C59331"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4238 3H18.8757V4.45186H17.4238V3Z",
    fill: "#C59331"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5195 3H15.9714V4.45186H14.5195V3Z",
    fill: "#C59331"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6543 8.80859H42.1062V10.2605H40.6543V8.80859Z",
    fill: "#C59331"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6543 11.7109H42.1062V13.1628H40.6543V11.7109Z",
    fill: "#C59331"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1035 10.2539H43.5554V11.7058H42.1035V10.2539Z",
    fill: "#C59331"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2012 10.2539H40.653V11.7058H39.2012V10.2539Z",
    fill: "#C59331"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.63086 18.2422H5.08272V19.694H3.63086V18.2422Z",
    fill: "#C59331"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.63086 21.1484H5.08272V22.6003H3.63086V21.1484Z",
    fill: "#C59331"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.08203 19.6953H6.53389V21.1472H5.08203V19.6953Z",
    fill: "#C59331"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.17578 19.6953H3.62764V21.1472H2.17578V19.6953Z",
    fill: "#C59331"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.63086 2.27344H5.08272V3.7253H3.63086V2.27344Z",
    fill: "#C59331"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.63086 5.17188H5.08272V6.62374H3.63086V5.17188Z",
    fill: "#C59331"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.08203 3.72266H6.53389V5.17452H5.08203V3.72266Z",
    fill: "#C59331"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.17578 3.72266H3.62764V5.17452H2.17578V3.72266Z",
    fill: "#C59331"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfinityQuickView);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/infinityQuickView.9548521b1e411898eb69231f6110642e.svg";